import { createUseStyles } from 'react-jss';
import { BagyPayThemeType } from '../../../styles';

type RuleNames =
    | 'modalContent'
    | 'modalTitle'
    | 'modalTextContent'
    | 'buttonContainer';

const styles = createUseStyles<RuleNames, unknown, BagyPayThemeType>(() => ({
    modalContent: {
        display: 'flex',
        position: 'relative',
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        maxWidth: 476,
        borderRadius: 16,
    },
    modalTitle: {
        fontWeight: 'bold',
        fontSize: 20,
        textAlign: 'center',
    },
    modalTextContent: {
        margin: '32px 0',
        textAlign: 'center',
        fontSize: 16,
        lineHeight: 1.22,
    },
    buttonContainer: {
        width: '100%',
        '& button': {
            margin: '5px 0',
        },
    },
}));

export default styles;
